var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnsuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#FDF4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1161 25.1161C25.6043 24.628 26.3957 24.628 26.8839 25.1161L32 30.2322L37.1161 25.1161C37.6043 24.628 38.3957 24.628 38.8839 25.1161C39.372 25.6043 39.372 26.3957 38.8839 26.8839L33.7678 32L38.8839 37.1161C39.372 37.6043 39.372 38.3957 38.8839 38.8839C38.3957 39.372 37.6043 39.372 37.1161 38.8839L32 33.7678L26.8839 38.8839C26.3957 39.372 25.6043 39.372 25.1161 38.8839C24.628 38.3957 24.628 37.6043 25.1161 37.1161L30.2322 32L25.1161 26.8839C24.628 26.3957 24.628 25.6043 25.1161 25.1161Z",
    fill: "#DF3939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsuccess);
export default __webpack_public_path__ + "static/media/unsuccess.d3e8a55f0792a9c32022f4150035f7c7.svg";
export { ForwardRef as ReactComponent };